// @ts-nocheck
// Exact live version restored from the production sourcemap (portal.rebels.io, 2026-10-23).
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import { NavigationUnderline, isNavigationActive } from '../../common/micro-interactions/NavigationUnderline';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate, useLocation, Outlet, Link } from 'react-router-dom';
import { HambergerMenu, Setting2 } from 'iconsax-react';
import logo from '../../../../../public/assets/logo.png';
import profilePicture from '../../../../../public/assets/profilePicture.svg';
import Avatar from '@mui/material/Avatar';
import { black500, yellowMain } from '../../../constants/color';
import { palette } from '../../../../theme/palette';
import { logout } from '@application/features/auth/authSlice';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { useEffect } from 'react';
import { getProfileAsync } from '@application/features/freelancer/freelancerThunks';
import './style.scss';
import { requestPortalNavigation } from './navigation-guard';
import { useFreelancerTaskCounts } from './useFreelancerTaskCounts';
const pages = [
    { label: 'Home', path: '/dashboard' },
    { label: 'My profile', path: '/my-profile' },
    { label: 'Vacancies', path: '/vacancies' },
    { label: 'My assignments', path: '/my-assignments' },
    { label: 'Documents', path: '/documents' },
    { label: 'Hour registration', path: '/hours-logging' },
    { label: 'Invoicing', path: '/invoicing' }
];
const settings = ['My profile', 'Need help?', 'Sign out'];
const theme = palette('light');
export const NaveBar = () => {
    const { freelancerProfile } = useAppSelector((state) => state.freelancer);
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const dispatch = useAppDispatch();
    const [anchorElSettings, setAnchorElSettings] = React.useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        dispatch(getProfileAsync());
    }, [dispatch, navigate]);
    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };
    const handleOpenSettingsMenu = (event) => {
        setAnchorElSettings(event.currentTarget);
    };
    const handleCloseSettingsMenu = (setting) => {
        if ((setting === 'Sign out' || setting === 'My profile') && !requestPortalNavigation())
            return;
        setAnchorElSettings(null);
        if (setting === 'Sign out') {
            dispatch(logout());
            navigate('/login');
        }
        if (setting === 'My profile') {
            navigate('/my-profile');
        }
    };
    const canNavigate = (path) => path !== location.pathname && requestPortalNavigation();
    // Filter pages based on contractType
    const { openTimeSheets, documentsToSign } = useFreelancerTaskCounts();
    const withCount = (label, count) => (count ? `${label} (${count})` : label);
    const filteredPages = pages
        .filter((page) => {
        if (freelancerProfile?.contractType?.toLowerCase() !== 'freelancer' && (page.path === '/vacancies' || page.path === '/invoicing')) {
            return false; // Hide these routes if contractType is not 'freelancer'
        }
        return true;
    })
        .map((page) => page.path === '/hours-logging'
        ? { ...page, label: withCount(page.label, openTimeSheets) }
        : page.path === '/documents'
            ? { ...page, label: withCount(page.label, documentsToSign) }
            : page);
    return _jsxs(_Fragment, {
        children: [
            _jsx(AppBar, {
                className: 'freelancer-navbar',
                position: 'fixed',
                sx: { background: theme.background.neutral, px: 1 },
                children: _jsx(Container, {
                    maxWidth: false,
                    sx: { background: '#FFFFFF', borderRadius: '25px', mt: 1 },
                    children: _jsxs(Toolbar, {
                        disableGutters: true,
                        style: { height: '80px' },
                        children: [
                            _jsx('img', { src: logo, alt: 'Rebels', style: { width: 150, maxWidth: '35vw', height: 'auto' } }),
                            _jsx(Box, { sx: { flexGrow: 1 } }),
                            _jsx(Box, {
                                sx: {
                                    display: { xs: 'none', md: 'none', lg: 'flex', xl: 'flex' }
                                },
                                children: _jsx(NavigationUnderline, { items: filteredPages, beforeNavigate: canNavigate })
                            }),
                            _jsx(Box, { sx: { flexGrow: 1 } }),
                            _jsxs(Box, {
                                sx: { display: 'flex', gap: '15px' },
                                children: [
                                    _jsx(Box, {
                                        children: _jsx(IconButton, {
                                            'aria-label': 'settings',
                                            onClick: handleOpenSettingsMenu,
                                            sx: { border: '1px solid #D7D7D7' },
                                            children: _jsx(Setting2, { style: { color: '#141414' } })
                                        })
                                    }),
                                    _jsx(Menu, {
                                        sx: { mt: 1 },
                                        id: 'settings-menu',
                                        anchorEl: anchorElSettings,
                                        open: Boolean(anchorElSettings),
                                        onClose: handleCloseSettingsMenu,
                                        children: settings.map((setting) => _jsx(MenuItem, {
                                            sx: {
                                                '&:hover': {
                                                    color: yellowMain
                                                }
                                            },
                                            onClick: () => handleCloseSettingsMenu(setting),
                                            children: setting
                                        }, setting))
                                    }),
                                    _jsx(Avatar, {
                                        sx: { display: { xs: 'none', sm: 'block' }, height: 42, width: 42 },
                                        src: freelancerProfile?.file || profilePicture,
                                        alt: 'Profile Image'
                                    }),
                                    _jsxs(Box, {
                                        sx: { display: { xs: 'flex', md: 'flex', lg: 'none' } },
                                        children: [
                                            _jsx(IconButton, {
                                                size: 'large',
                                                'aria-label': 'Open navigation',
                                                'aria-expanded': Boolean(anchorElNav),
                                                'aria-controls': 'menu-appbar',
                                                'aria-haspopup': 'true',
                                                onClick: handleOpenNavMenu,
                                                color: 'inherit',
                                                children: _jsx(HambergerMenu, { style: { color: black500 } })
                                            }),
                                            _jsx(Menu, {
                                                id: 'menu-appbar',
                                                anchorEl: anchorElNav,
                                                anchorOrigin: {
                                                    vertical: 'bottom',
                                                    horizontal: 'left'
                                                },
                                                keepMounted: true,
                                                transformOrigin: {
                                                    vertical: 'top',
                                                    horizontal: 'left'
                                                },
                                                open: Boolean(anchorElNav),
                                                onClose: handleCloseNavMenu,
                                                sx: { display: { xs: 'block', lg: 'block', xl: 'none' } },
                                                children: filteredPages.map((page) => _jsx(MenuItem, {
                                                    component: Link,
                                                    to: page.path,
                                                    'aria-current': isNavigationActive(location.pathname, page.path)
                                                        ? 'page'
                                                        : undefined,
                                                    selected: isNavigationActive(location.pathname, page.path),
                                                    onClick: (event) => {
                                                        if (event.button !== 0 ||
                                                            event.metaKey ||
                                                            event.ctrlKey ||
                                                            event.shiftKey ||
                                                            event.altKey)
                                                            return;
                                                        if (!canNavigate(page.path)) {
                                                            event.preventDefault();
                                                            return;
                                                        }
                                                        handleCloseNavMenu();
                                                    },
                                                    children: _jsx(Typography, { textAlign: 'center', children: page.label })
                                                }, page.path))
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            _jsx(Outlet, {})
        ]
    });
};
